<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content d-flex flex-row" v-menu-permission="'list'">
            <!--EmFilterTree-->
            <DrawerHandler :openWidth="23" is-left class="col-lg-3 float-lg-left overflow-auto" style="height:750px" to-invisible>
                <em-filter-tree
                            ref="emTree"
                            filterEnable checkEnable
                            :entity="modelName"
                            filterState="levelTreeFilter"
                            loadState="levelTreeNodes"
                            :node-appender="formatText"
                            textKeys="formattedText"
                            :selectedId="$_emLevelTreeListMixin_menuTreeSelectedId"
                            @onclick="$_emLevelTreeListMixin_menuTreeOnClick"></em-filter-tree>
            </DrawerHandler>
            <div class="float-lg-right col-lg-9">
                <div id="accordionFilter" class="content">
                    <div class="card">
                        <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                             data-parent="#accordionFilter">
                            <div class="card-body">
                                <form>
                                    <em-filter :entity="modelName" ref="emListFilter"
                                               @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"/>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="sithMesMstBasicHeaderResultTable" class="content">
                    <div class="card my-1">
                        <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                             data-parent="#accordionResult">
                            <div class="card-body">
                                <em-table :entity="modelName"
                                          ref="emTable"
                                          edit-disable
                                          withCustomRowActions exportDisabled :inlineActionsDisabled="prop_inline!=='1'"
                                          @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                          @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                    <template #left-header>
                                        <em-button type="delete"
                                                custom-label="批量删除"
                                                v-bind:class="'btn btn-outline-primary btn-sm'"
                                                @click="deleteBatch()"
                                                :busy="onBachDelete"
                                        >
                                        </em-button>
                                        <em-button type="edit" custom-icon="fa fa-fw fa-lg fa-file-import"
                                            :disabled= false
                                            custom-label="导入标准套工单"
                                            v-bind:class="'btn btn-outline-primary btn-sm'"
                                            v-b-modal.modal-updateBasicHeader>
                                        </em-button>
                                    </template>
                                    <template #customRowActions="{row}">
                                        <b-button-group>
                                            <em-button
                                                    v-if="$_emLevelTreeListMixin_getGrandParentId(row)"
                                                    type="gotoGrandParent"
                                                    v-bind:class="'btn btn-outline-primary btn-sm'"
                                                    @click="$_emLevelTreeListMixin_gotoGrandParentLevel(row)">
                                            </em-button>
                                            <em-button type="gotoChild"
                                                       v-bind:class="'btn btn-outline-primary btn-sm'"
                                                       @click="$_emLevelTreeListMixin_gotoChild(row)">
                                            </em-button>
                                        </b-button-group>
                                    </template>
                                </em-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"/>
        <b-modal id="modal-updateBasicHeader" title="导入标准套工单" hide-footer>
            <b-form @submit="handleSubmit" @reset="handleReset">
            <b-form-group
            id="machineType"
            label="机型:"
            label-for="input-machineType"
            invalid-feedback="必须选择机型"
        >
                <b-form-select id="input-machineType" v-model="selectedMachineType" :options="machineTypes"
                         required></b-form-select>
            </b-form-group>

            <b-form-group
            id="templateFile"
            label="选择数据源文件:"
            label-for="input-dataFile"
            invalid-feedback="必须选择数据源">
            <b-form-file id="input-dataFile" v-model="file" ref="file-input" class="mb-2 w-100" :browse-text="$t('btn.basic.browse')" placeholder="请选择数据文件" :file-name-formatter="formatNames" accept=".xlsx" required></b-form-file>
            </b-form-group>

            <div class="form-check mt-2">
                <input class="form-check-input is-invalid" type="checkbox" value="" id="agreement" aria-describedby="invalidCheckFeedback" required>
                <label class="form-check-label" for="agreement">确认覆盖原始数据</label>
                <!-- <div id="invalidCheckFeedback" class="invalid-feedback">请确认</div> -->
            </div>

            <b-row align-h="end" style="margin-top: 30px">
          <b-button type="submit" variant="primary">导入</b-button>
          <b-button type="reset" variant="light">取消</b-button>
        </b-row>
        </b-form>
        </b-modal>
    </div>
</template>
<script>
    // Author Lin
    // Date 2021-05-06 11:55:20

    import emLevelTreeListMixin from "@/mixin/em/levelTree/list";
    import EmFilterTree from "@/components/em/EmFilterTree";
    import DrawerHandler from "@/components/echarts-part/CalendarShift/cells/stuffs/DrawerHandler";
    import EmFilter from "@/components/em/EmFilter";
    import emCommonApiMixin from "@/mixin/em/common/api";
    import commonViewsUtil from "@/utils/commonViewsUtil";

    export default {
        name: "sithMesMstBasicHeaderLevelTreeListView",
        mixins: [emLevelTreeListMixin,emCommonApiMixin],
        components: {DrawerHandler, EmFilter, EmFilterTree},
        props:{
            //是否启用行编辑
            prop_inline: {
                type: String,
                default: "0"
            }
        },
        data() {
            return {
                file: null,
                machineTypes: [],
                selectedMachineType:null,
                onBachDelete: false,
            }
        },
        methods: {
            formatText(nodeDate) {
                let formattedText = `${nodeDate.cn}:${nodeDate.machineName}`
                return Object.assign({formattedText}, nodeDate)
            },
            deleteBatch() {
                this.onBachDelete = true
                let checkedNodes = this.$refs.emTree.getCheckedNodes();
                let tempList = []
                for (let item of checkedNodes) {
                    tempList.push(item.id);
                }
                if (tempList.length === 0) {
                    this.$message.warning("没有选择任何标准套工单");
                    this.onBachDelete = false;
                    return;
                }
                let url = `${this.$_emApiMixin_entityBaseApi("sithMesMstBasicHeader")}/batchDeleteWithSub?ids=${tempList.join(",")}`
                this.$_emApiMixin_delete(url, {})
                    .then(response => {
                        commonViewsUtil.showSuccess(this, "批量删除成功")
                        this.$refs.emListFilter.doQuery()
                    }).finally(() => this.onBachDelete = false)
            },
            formatNames(files) {
                return files.length === 1 ? files[0].name : `${files.length} files selected`
            },
            getMachineTypes() {
                var compare = function (obj1, obj2) {
                var val1 = obj1.text;
                var val2 = obj2.text;
                if (val1 < val2) {
                    return -1;
                } else if (val1 > val2) {
                    return 1;
                } else {
                    return 0;
                }            
                } 
                this.$_emApiMixin_findByFilter("sithMesMstMachineType", {}).then(
                    (data) => {
                    let arry = data.map((m) => {
                        return { value: m.id, text: m.name };
                    });
                    this.machineTypes = arry.sort(compare);
                    }
                );
            },
            handleSubmit(event) {
                event.preventDefault()
                var formData = new FormData();
                formData.append('file',this.file);
                formData.append('machineType',this.selectedMachineType);

                this.$_emApiMixin_post(`${this.$_emApiMixin_entityBaseApi(this.modelName)}/updateData`, formData)
                .then(response => {
                    commonViewsUtil.showSuccess(this, "更新成功")
                    this.$refs.emListFilter.doQuery()
                })

                 this.$nextTick(() => {
                    this.$bvModal.hide('modal-updateBasicHeader')
                })
            },
            handleReset() {
                this.selectedMachineType = null;
                this.file = null;
                this.$nextTick(() => {
                    this.$bvModal.hide('modal-updateBasicHeader')
                })
            },
        },
        mounted() {
            //监听modal的show事件
            this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
            console.log('Modal is about to be shown', bvEvent, modalId)
            if (modalId === "modal-updateBasicHeader") {
                this.getMachineTypes()
                }
            })
        }
    }
</script>
<style scoped>
.w-100 >>> .b-form-file .custom-file-label {
    width: 100%;
}
.w-100 >>> .custom-file-label {
    width: 100%;
}
</style>